import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../components/content/axiosConfig';
import { queryKeys } from './queryKeys';

export function useDashboardSuper(options = {}) {
  return useQuery({
    queryKey: queryKeys.dashboardSuper(),
    queryFn: async () => {
      const response = await axiosInstance.get('api/DashBoardSuper/GetReport');
      return response.data ?? {};
    },
    staleTime: 2 * 60_000,
    ...options,
  });
}
